import { render, staticRenderFns } from "./generatePromo.vue?vue&type=template&id=3352e369&scoped=true&"
import script from "./generatePromo.vue?vue&type=script&lang=js&"
export * from "./generatePromo.vue?vue&type=script&lang=js&"
import style0 from "./generatePromo.vue?vue&type=style&index=0&id=3352e369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352e369",
  null
  
)

component.options.__file = "generatePromo.vue"
export default component.exports